
























































import Vue from 'vue'

import { PaySlipForReleaseDTO } from '@/DTOs/PaySlipForReleaseDTO'
import { client } from '@/services/ApiClient'
import { formatDate } from '@/utils'

export default Vue.extend({
  name: 'Release',

  beforeRouteEnter(to, from, next) {
    // User must be logged in. Otherwise redirect to login.
    next(vm => {
      const { isLoggedIn, user } = vm.$root.$data
      const canSee = isLoggedIn && user.isAdmin
      if (!canSee) {
        vm.$router.replace({ name: 'Login' })
      }
    })
  },

  data: () => ({
    headers: [
      {
        text: 'Name',
        align: 'start',
        sortable: true,
        value: 'employeeName',
        filterable: true,
      },
      {
        text: 'Email',
        align: 'start',
        sortable: false,
        value: 'employeeEmail',
      },
      {
        text: 'Date',
        align: 'right',
        sortable: true,
        value: 'date',
      },
      {
        text: 'Released',
        align: 'center',
        sortable: true,
        value: 'isReleased',
      },
      {
        text: 'Actions',
        align: 'end',
        sortable: false,
        value: 'actions',
      },
    ],
    paySlips: [] as PaySlipForReleaseDTO[],
    isLoading: true as boolean,
    search: '',
  }),

  async created() {
    this.paySlips = await client.getPaySlipsForRelease()
    this.isLoading = false
  },

  methods: {
    formatDate,
    onReleaseCheckboxClick(item: PaySlipForReleaseDTO) {
      item.isReleased ? this.unrelease(item) : this.release(item)
    },
    async release({ id }: PaySlipForReleaseDTO) {
      this.isLoading = true
      const paySlip = await client.releasePaySlip(id)
      this.updatePaySlip(paySlip)
      this.isLoading = false
    },
    async unrelease({ id }: PaySlipForReleaseDTO) {
      this.isLoading = true
      const paySlip = await client.unreleasePaySlip(id)
      this.updatePaySlip(paySlip)
      this.isLoading = false
    },
    async trash({ id }: PaySlipForReleaseDTO) {
      this.isLoading = true
      await client.trashPaySlip(id)
      this.paySlips = this.paySlips.filter(p => p.id !== id)
      this.isLoading = false
    },
    updatePaySlip(paySlip: PaySlipForReleaseDTO): void {
      this.paySlips = this.paySlips.map(i => (i.id === paySlip.id ? paySlip : i))
    },
  },
})
